import { TransitOperationLogResponse } from '../../../../api/models'
import { FunctionalError, TransitOperationLog } from './types'
import { TransitOperationLogFunctionalErrorResponse } from '../../../../api/models/transit-operation-log-functional-error-response'

function fromFunctionalErrorResponse(response: TransitOperationLogFunctionalErrorResponse): FunctionalError {
  return {
    type: response.type ?? '',
    reason: response.reason ?? '',
    pointer: response.pointer ?? '',
    originalAttributeValue: response.originalAttributeValue ?? '',
    description: response.description ?? '',
  }
}

export function fromFunctionalErrorResponses(responses: TransitOperationLogFunctionalErrorResponse[]): FunctionalError[] {
  return responses.map(fromFunctionalErrorResponse)
}

export function fromTransitOperationLogResponse(response: TransitOperationLogResponse): TransitOperationLog {
  return {
    id: response.id,
    messageContext: response.messageContext ?? '',
    created: response.created,
  }
}

export function fromTransitOperationLogResponses(responses: TransitOperationLogResponse[]) {
  return responses.map((response) => fromTransitOperationLogResponse(response))
}
